import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    // const intern_button = document.querySelector('[data-behaviour="toggle-intern"]');
    //
    // intern_button.addEventListener('click', () => {
    //     document.body.classList.toggle('body--intern');
    // })

    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    //Show hide
    let listToggleElements = [...document.querySelectorAll('[data-behaviour="list-toggle"]')];

    listToggleElements.forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            const item = element.parentNode.parentNode;
            item.classList.toggle("list_item--visible");

            listToggleElements.filter(e => e.parentNode.parentNode != item).forEach((e) => {
                e.parentNode.parentNode.classList.remove("list_item--visible")
            });

            const button = element.querySelector(".link--more");

            if (item.classList.contains("list_item--visible")) {
                button.innerHTML = "Schließen";
            } else {
                button.innerHTML = "Mehr Lesen";
            }
        });
    });

    //FAQ
    const faqs = document.querySelectorAll('[data-behaviour="faq"]');

    faqs.forEach((faq) => {
        const items = [...faq.querySelectorAll('.list_item')];
        const faqMore = faq.querySelector('[data-behaviour="faq_more"]');
        faqMore.addEventListener('click', e => {
            items.forEach(element => {
                element.classList.remove('list_item--more');
            })
            faqMore.style.display = 'none';
        })
        const faqSearch = faq.querySelector('[data-behaviour="faq_search"]');
        faqSearch.addEventListener('keyup', e => {
            const query = faqSearch.value.toLowerCase();
            items.forEach(item => {
                item.classList.remove('list_item--more');
            });
            faqMore.style.display = 'none';
            if (!query) {
                return;
            }
            // console.log(items.filter(item => !item.innerText.toLowerCase().indexOf(query) !== -1));
            items.filter(item => item.innerText.toLowerCase().indexOf(query) === -1)
                .forEach(item => item.classList.add('list_item--more'))
        })
    });

    //Reviews
    let reviewToggleElements = [...document.querySelectorAll('[data-behaviour="review-toggle"]')];

    reviewToggleElements.forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            const item = element.parentNode.parentNode.parentNode;
            item.classList.toggle("review--open");
        });
    });

    //Members
    let memberToggleElements = [...document.querySelectorAll('[data-behaviour="member-toggle"]')];

    memberToggleElements.forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            const item = element.parentNode.parentNode.parentNode;
            item.classList.toggle("member--open");
        });
    });
});
